import {
	cond,
	conforms,
	constant,
	identity,
	isObject,
	isString,
	mapValues,
	matches,
	overSome,
	replace,
	startsWith,
	stubTrue,
	update,
} from 'lodash/fp';

import {
	SanitizeReduxActions,
	SanitizeReduxState,
	SanitizeSentryEvent,
} from '@skippay/core/global/errorTracking';
import { PIN_CREATE, PIN_LOGIN, PIN_VERIFICATION } from '@skippay/core/modules/clientInfo';
import { evolve } from '@skippay/core/utils/fp';

import { LOGIN } from 'modules/auth/actions';

export const SANITIZED = `*SANITIZED*`;

export const sanitizeReduxState: SanitizeReduxState = mapValues((value, key) => {
	if (isString(value) && key === `password`) {
		return SANITIZED;
	}
	return isObject(value) ? sanitizeReduxState(value) : value;
});

const SENSITIVE_ACTION_TYPES = [LOGIN, PIN_CREATE, PIN_LOGIN, PIN_VERIFICATION];

export const sanitizeReduxActions: SanitizeReduxActions = cond([
	[
		conforms({
			meta: matches({ field: `password` }),
			type: startsWith(`@@redux-form`),
		}),
		update([`payload`], constant(SANITIZED)),
	],
	[
		overSome(SENSITIVE_ACTION_TYPES.map((type) => matches({ type }))),
		update([`payload`], constant(SANITIZED)),
	],
	[stubTrue, identity],
]);

const sanitizeSimpleId = replace(/(\/overeni-mobilem.*[?&]token=)(\w+)/, `$1${SANITIZED}`);
export const sanitizeSentryEvent: SanitizeSentryEvent = update(
	[`request`],
	evolve({
		url: sanitizeSimpleId,
		headers: {
			Referer: sanitizeSimpleId,
		},
	})
);
